import React from 'react';
import './sub-content.scss';

export default function SubContent({ children }) {
  return <div className="sub-content">{ children }</div>;
}
